import '../assets/NcProfileHoverCard-D3V682nS.css';
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import { getCurrentUser } from "@nextcloud/auth";
import axios from "@nextcloud/axios";
import { getCapabilities } from "@nextcloud/capabilities";
import { getCanonicalLocale } from "@nextcloud/l10n";
import { generateUrl, generateOcsUrl } from "@nextcloud/router";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
import { N as NcActionButton } from "./NcActionButton-D7uypboC.mjs";
import NcActionLink from "../Components/NcActionLink.mjs";
import NcActionRouter from "../Components/NcActionRouter.mjs";
import { N as NcActions } from "./NcActions-CX1MSord.mjs";
import { N as NcAvatar } from "./NcAvatar-C1ty7wsG.mjs";
import { N as NcButton } from "./NcButton-DAGirW_B.mjs";
import NcEmptyContent from "../Components/NcEmptyContent.mjs";
import NcLoadingIcon from "../Components/NcLoadingIcon.mjs";
import { N as NcRichText } from "./NcRichText-K2ZjNIbK.mjs";
import { useIsSmallMobile } from "../Composables/useIsMobile.mjs";
import { r as register, U as t1, a as t } from "./_l10n-CAnZaLWU.mjs";
import { l as logger } from "./logger-D3RVzcfQ.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
const _sfc_main$5 = {
  name: "AccountOutlineIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$5 = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon account-outline-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M12,13C14.67,13 20,14.33 20,17V20H4V17C4,14.33 9.33,13 12,13M12,14.9C9.03,14.9 5.9,16.36 5.9,17V18.1H18.1V17C18.1,16.36 14.97,14.9 12,14.9Z" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$5 = [];
var __component__$5 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$5,
  _sfc_render$5,
  _sfc_staticRenderFns$5,
  false,
  null,
  null
);
const AccountIcon = __component__$5.exports;
const _sfc_main$4 = {
  name: "BriefcaseOutlineIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$4 = function render2() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon briefcase-outline-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M20,6C20.58,6 21.05,6.2 21.42,6.59C21.8,7 22,7.45 22,8V19C22,19.55 21.8,20 21.42,20.41C21.05,20.8 20.58,21 20,21H4C3.42,21 2.95,20.8 2.58,20.41C2.2,20 2,19.55 2,19V8C2,7.45 2.2,7 2.58,6.59C2.95,6.2 3.42,6 4,6H8V4C8,3.42 8.2,2.95 8.58,2.58C8.95,2.2 9.42,2 10,2H14C14.58,2 15.05,2.2 15.42,2.58C15.8,2.95 16,3.42 16,4V6H20M4,8V19H20V8H4M14,6V4H10V6H14Z" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$4 = [];
var __component__$4 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$4,
  _sfc_render$4,
  _sfc_staticRenderFns$4,
  false,
  null,
  null
);
const BriefcaseIcon = __component__$4.exports;
const _sfc_main$3 = {
  name: "ClockOutlineIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$3 = function render3() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon clock-outline-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$3 = [];
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$3,
  _sfc_render$3,
  _sfc_staticRenderFns$3,
  false,
  null,
  null
);
const ClockIcon = __component__$3.exports;
const _sfc_main$2 = {
  name: "MapMarkerOutlineIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$2 = function render4() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon map-marker-outline-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5M12,2A7,7 0 0,1 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9C7,10 7,12 12,18.71C17,12 17,10 17,9A5,5 0 0,0 12,4Z" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$2 = [];
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$2,
  _sfc_render$2,
  _sfc_staticRenderFns$2,
  false,
  null,
  null
);
const MapMarkerIcon = __component__$2.exports;
const _sfc_main$1 = {
  name: "PencilOutlineIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$1 = function render5() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon pencil-outline-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$1 = [];
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$1,
  _sfc_render$1,
  _sfc_staticRenderFns$1,
  false,
  null,
  null
);
const PencilIcon = __component__$1.exports;
register(t1);
/*!
 * SPDX-FileCopyrightText: 2026 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const PROFILE_CACHE_TTL_MS = 30 * 60 * 1e3;
const cache = /* @__PURE__ */ new Map();
const inflight = /* @__PURE__ */ new Map();
function getCachedProfile(userId) {
  const entry = cache.get(userId);
  if (!entry) {
    return null;
  }
  if (Date.now() >= entry.expiresAt) {
    cache.delete(userId);
    return null;
  }
  return entry.data;
}
function setCachedProfile(userId, data, ttlMs = PROFILE_CACHE_TTL_MS) {
  cache.set(userId, {
    data,
    expiresAt: Date.now() + ttlMs
  });
}
async function fetchProfileCached(userId, fetcher, ttlMs = PROFILE_CACHE_TTL_MS) {
  const cached = getCachedProfile(userId);
  if (cached) {
    return cached;
  }
  const pending = inflight.get(userId);
  if (pending) {
    return pending;
  }
  const promise = (async () => {
    try {
      const data = await fetcher();
      if (data) {
        setCachedProfile(userId, data, ttlMs);
      }
      return data;
    } finally {
      inflight.delete(userId);
    }
  })();
  inflight.set(userId, promise);
  return promise;
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcProfileHoverCard",
  props: {
    user: { default: null },
    profile: { default: null },
    preloadedUserStatus: { default: null },
    open: { type: Boolean, default: false },
    actions: { default: null },
    actionsLoading: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const loading = ref(false);
    const error = ref(false);
    const profileData = ref(props.profile);
    const userStatus = ref(props.preloadedUserStatus ?? {});
    const isMobile = useIsSmallMobile();
    if (props.user && props.profile) {
      setCachedProfile(props.user, props.profile);
    }
    const isCurrentUser = computed(() => !!props.user && getCurrentUser()?.uid === props.user);
    const settingsUrl = generateUrl("/settings/user");
    const resolvedActions = computed(() => {
      if (props.actions && props.actions.length > 0) {
        return props.actions.filter((action) => action.appId !== "timezone");
      }
      return (profileData.value?.actions ?? []).filter((action) => action.appId !== "timezone").map((action) => ({
        id: action.id,
        appId: action.appId,
        text: action.title,
        href: action.target || void 0,
        icon: action.icon,
        target: action.id === "phone" ? "_self" : "_blank",
        rel: action.id === "fediverse" ? "me" : void 0
      }));
    });
    const localTimeLabel = computed(() => {
      const time = formatProfileLocalTime(/* @__PURE__ */ new Date());
      if (!time) {
        return null;
      }
      return t("Local time: {time}", { time });
    });
    const primaryAction = computed(() => resolvedActions.value[0]);
    const otherActions = computed(() => resolvedActions.value.slice(1));
    const primaryActionButtonProps = computed(() => {
      const action = primaryAction.value;
      if (!action) {
        return {};
      }
      if (action.to) {
        return { to: action.to };
      }
      if (action.href) {
        return {
          href: action.href,
          target: action.target ?? (action.href.startsWith("tel:") ? "_self" : "_blank"),
          rel: action.rel
        };
      }
      return {};
    });
    const emptyProfileMessage = computed(() => {
      if (isCurrentUser.value) {
        return t("You have not added any info yet");
      }
      const name = profileData.value?.displayname || props.user || "";
      return t("{user} has not added any info yet", { user: name });
    });
    const avatarUserStatus = computed(() => ({
      status: userStatus.value.status ?? null,
      icon: userStatus.value.icon ?? null,
      message: userStatus.value.message ?? null
    }));
    function formatProfileLocalTime(date) {
      const timeZone = profileData.value?.timezone;
      if (timeZone) {
        try {
          return new Intl.DateTimeFormat(getCanonicalLocale(), {
            timeZone,
            hour: "2-digit",
            minute: "2-digit"
          }).format(date);
        } catch {
        }
      }
      if (typeof profileData.value?.timezoneOffset === "number") {
        const shifted = new Date(date.getTime() + profileData.value.timezoneOffset * 1e3);
        return new Intl.DateTimeFormat(getCanonicalLocale(), {
          timeZone: "UTC",
          hour: "2-digit",
          minute: "2-digit"
        }).format(shifted);
      }
      return null;
    }
    function isIconUrl(icon) {
      return !!icon && (/^(https?:)?\/\//.test(icon) || icon.startsWith("/") || icon.startsWith("data:"));
    }
    function otherActionComponent(action) {
      if (action.to) {
        return NcActionRouter;
      }
      if (action.onClick && !action.href) {
        return NcActionButton;
      }
      return NcActionLink;
    }
    function otherActionProps(action) {
      if (action.to) {
        return { to: action.to, closeAfterClick: true };
      }
      if (action.onClick && !action.href) {
        return { closeAfterClick: true };
      }
      return {
        href: action.href,
        target: action.target ?? (action.href?.startsWith("tel:") ? "_self" : "_blank"),
        rel: action.rel,
        closeAfterClick: true
      };
    }
    watch(() => props.profile, (value) => {
      if (value) {
        profileData.value = value;
        if (props.user) {
          setCachedProfile(props.user, value);
        }
        error.value = false;
      }
    });
    watch(() => props.preloadedUserStatus, (value) => {
      if (value) {
        userStatus.value = value;
      }
    });
    watch(() => props.user, () => {
      profileData.value = props.profile;
      userStatus.value = props.preloadedUserStatus ?? {};
      error.value = false;
      if (props.user && props.profile) {
        setCachedProfile(props.user, props.profile);
      }
      if (props.open) {
        loadProfile();
      }
    });
    watch(() => props.open, (isOpen) => {
      if (isOpen) {
        loadProfile();
      }
    });
    onMounted(() => {
      if (props.open) {
        loadProfile();
      }
    });
    function hasPreloadedUserStatus() {
      return props.preloadedUserStatus !== null || !!(userStatus.value.icon || userStatus.value.message || userStatus.value.status);
    }
    async function ensureUserStatus(userId) {
      if (!hasPreloadedUserStatus()) {
        userStatus.value = await fetchUserStatus(userId);
      }
    }
    async function loadProfile() {
      if (!props.user || loading.value) {
        return;
      }
      const userId = props.user;
      if (!profileData.value) {
        const cached = getCachedProfile(userId);
        if (cached) {
          profileData.value = cached;
        }
      }
      if (profileData.value) {
        await ensureUserStatus(userId);
        return;
      }
      loading.value = true;
      error.value = false;
      try {
        const [profile, status] = await Promise.all([
          fetchProfileCached(userId, async () => {
            const { data } = await axios.get(generateOcsUrl("/profile/{userId}", { userId }));
            return data.ocs?.data ?? null;
          }),
          hasPreloadedUserStatus() ? Promise.resolve(userStatus.value) : fetchUserStatus(userId)
        ]);
        profileData.value = profile;
        userStatus.value = status;
        if (!profileData.value) {
          error.value = true;
        }
      } catch (e) {
        logger.debug("Failed to load profile for hovercard", { error: e, user: userId });
        error.value = true;
      } finally {
        loading.value = false;
      }
    }
    async function fetchUserStatus(userId) {
      try {
        if (!getCapabilities()?.user_status?.enabled || !getCurrentUser()) {
          return {};
        }
        const { data } = await axios.get(generateOcsUrl("/apps/user_status/api/v1/statuses/{userId}", { userId }));
        return data.ocs?.data ?? {};
      } catch (e) {
        logger.debug("Failed to load user status for hovercard", { error: e, userId });
        return {};
      }
    }
    return { __sfc: true, props, loading, error, profileData, userStatus, isMobile, isCurrentUser, settingsUrl, resolvedActions, localTimeLabel, primaryAction, otherActions, primaryActionButtonProps, emptyProfileMessage, avatarUserStatus, formatProfileLocalTime, isIconUrl, otherActionComponent, otherActionProps, hasPreloadedUserStatus, ensureUserStatus, loadProfile, fetchUserStatus, AccountIcon, BriefcaseIcon, ClockIcon, MapMarkerIcon, PencilIcon, NcActions, NcAvatar, NcButton, NcEmptyContent, NcLoadingIcon, NcRichText, t, NcIconSvgWrapper };
  }
});
var _sfc_render = function render6() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "profile-hover-card", attrs: { "role": "dialog", "aria-label": _setup.t("Profile of {user}", { user: _setup.profileData?.displayname || _vm.user || "" }) } }, [_setup.loading ? _c("div", { staticClass: "profile-hover-card__loading" }, [_c(_setup.NcLoadingIcon, { attrs: { "size": 32, "name": _setup.t("Loading profile") } })], 1) : _setup.profileData && !_setup.error ? [_c("div", { staticClass: "profile-hover-card__header" }, [_setup.isCurrentUser ? _c(_setup.NcButton, { staticClass: "profile-hover-card__header__edit", attrs: { "variant": "tertiary", "aria-label": _setup.t("Edit profile"), "title": _setup.t("Edit profile"), "href": _setup.settingsUrl, "target": "_blank" }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_c(_setup.PencilIcon, { attrs: { "size": 20 } })];
  }, proxy: true }], null, false, 3660207582) }) : _vm._e(), _c("div", { staticClass: "profile-hover-card__header__container" }, [_setup.isMobile ? _c(_setup.NcAvatar, { staticClass: "avatar profile-hover-card__header__container__avatar", attrs: { "user": _setup.profileData.userId, "size": 96, "disableMenu": "", "disableTooltip": "", "preloadedUserStatus": _setup.avatarUserStatus, "isNoUser": !_setup.profileData.isUserAvatarVisible } }) : _c("div", { staticClass: "profile-hover-card__header__container__placeholder" }), _c("div", { staticClass: "profile-hover-card__header__container__identity" }, [_c("div", { staticClass: "profile-hover-card__header__container__displayname" }, [_c("h2", [_vm._v(_vm._s(_setup.profileData.displayname || _setup.profileData.userId))]), _setup.profileData.pronouns ? _c("span", { staticClass: "profile-hover-card__header__container__pronoun-separator" }, [_vm._v("·")]) : _vm._e(), _setup.profileData.pronouns ? _c("span", { staticClass: "profile-hover-card__header__container__pronouns" }, [_vm._v(_vm._s(_setup.profileData.pronouns))]) : _vm._e()]), _setup.userStatus.icon || _setup.userStatus.message ? _c("div", { staticClass: "profile-hover-card__header__container__status" }, [_c("span", { staticClass: "profile-hover-card__header__container__status-content" }, [_c("span", [_vm._v(_vm._s(_setup.userStatus.icon) + " " + _vm._s(_setup.userStatus.message))])])]) : _vm._e()])], 1)], 1), _c("div", { staticClass: "profile-hover-card__body" }, [_c("div", { staticClass: "profile-hover-card__content" }, [_c("div", { staticClass: "profile-hover-card__sidebar" }, [!_setup.isMobile ? _c(_setup.NcAvatar, { staticClass: "avatar", attrs: { "user": _setup.profileData.userId, "size": 135, "disableMenu": "", "disableTooltip": "", "preloadedUserStatus": _setup.avatarUserStatus, "isNoUser": !_setup.profileData.isUserAvatarVisible } }) : _vm._e(), _c("div", { staticClass: "user-actions" }, [_vm.actionsLoading && _setup.resolvedActions.length === 0 ? _c("div", { staticClass: "user-actions__loading" }, [_c(_setup.NcLoadingIcon, { attrs: { "size": 20, "name": _setup.t("Loading actions") } })], 1) : [_setup.primaryAction ? _c(_setup.NcButton, _vm._b({ staticClass: "user-actions__primary", attrs: { "variant": "primary" }, on: { "click": _setup.primaryAction.onClick }, scopedSlots: _vm._u([_setup.primaryAction.iconSvg || _setup.primaryAction.icon ? { key: "icon", fn: function() {
    return [_setup.primaryAction.iconSvg ? _c(_setup.NcIconSvgWrapper, { attrs: { "svg": _setup.primaryAction.iconSvg } }) : _setup.isIconUrl(_setup.primaryAction.icon) ? _c("img", { staticClass: "user-actions__primary__icon", attrs: { "src": _setup.primaryAction.icon, "alt": "" } }) : _c("span", { staticClass: "user-actions__primary__icon-class", class: _setup.primaryAction.icon, attrs: { "aria-hidden": "true" } })];
  }, proxy: true } : null], null, true) }, "NcButton", _setup.primaryActionButtonProps, false), [_vm._v(" " + _vm._s(_setup.primaryAction.text) + " ")]) : _vm._e(), _setup.otherActions.length > 0 ? _c(_setup.NcActions, { staticClass: "user-actions__other", attrs: { "inline": _setup.isMobile ? 5 : 4 } }, _vm._l(_setup.otherActions, function(action, index) {
    return _c(_setup.otherActionComponent(action), _vm._b({ key: action.id || action.href || index, tag: "component", on: { "click": action.onClick }, scopedSlots: _vm._u([action.iconSvg || action.icon ? { key: "icon", fn: function() {
      return [action.iconSvg ? _c(_setup.NcIconSvgWrapper, { attrs: { "svg": action.iconSvg } }) : _setup.isIconUrl(action.icon) ? _c("img", { staticClass: "user-actions__other__icon", attrs: { "src": action.icon, "alt": "" } }) : _c("span", { staticClass: "user-actions__other__icon-class", class: action.icon, attrs: { "aria-hidden": "true" } })];
    }, proxy: true } : null], null, true) }, "component", _setup.otherActionProps(action), false), [_vm._v(" " + _vm._s(action.text) + " ")]);
  }), 1) : _vm._e()]], 2)], 1), _c("div", { staticClass: "profile-hover-card__blocks" }, [_setup.profileData.organisation || _setup.profileData.role || _setup.profileData.address || _setup.localTimeLabel ? _c("div", { staticClass: "profile-hover-card__blocks-details" }, [_setup.profileData.organisation || _setup.profileData.role ? _c("div", { staticClass: "detail" }, [_c("p", [_c(_setup.BriefcaseIcon, { staticClass: "detail-icon", attrs: { "size": 16, "title": "" } }), _vm._v(" " + _vm._s(_setup.profileData.organisation) + " "), _setup.profileData.organisation && _setup.profileData.role ? _c("span", [_vm._v("•")]) : _vm._e(), _vm._v(" " + _vm._s(_setup.profileData.role) + " ")], 1)]) : _vm._e(), _setup.profileData.address ? _c("div", { staticClass: "detail" }, [_c("p", [_c(_setup.MapMarkerIcon, { staticClass: "detail-icon", attrs: { "size": 16, "title": "" } }), _vm._v(" " + _vm._s(_setup.profileData.address) + " ")], 1)]) : _vm._e(), _setup.localTimeLabel ? _c("div", { staticClass: "detail" }, [_c("p", [_c(_setup.ClockIcon, { staticClass: "detail-icon", attrs: { "size": 16, "title": "" } }), _vm._v(" " + _vm._s(_setup.localTimeLabel) + " ")], 1)]) : _vm._e()]) : _vm._e(), _setup.profileData.headline || _setup.profileData.biography ? [_setup.profileData.headline ? _c("h3", { staticClass: "profile-hover-card__blocks-headline" }, [_vm._v(" " + _vm._s(_setup.profileData.headline) + " ")]) : _vm._e(), _setup.profileData.biography ? _c("div", { staticClass: "profile-hover-card__blocks-biography" }, [_c(_setup.NcRichText, { attrs: { "text": _setup.profileData.biography, "useExtendedMarkdown": "" } })], 1) : _vm._e()] : _c(_setup.NcEmptyContent, { staticClass: "profile-hover-card__blocks-empty-info", attrs: { "name": _setup.emptyProfileMessage, "description": _setup.t("The headline and about sections will show up here") }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_c(_setup.AccountIcon, { attrs: { "size": 40 } })];
  }, proxy: true }]) })], 2)])])] : _c("div", { staticClass: "profile-hover-card__error" }, [_vm._v(" " + _vm._s(_setup.t("Failed to load profile")) + " ")])], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "cf5e55fe"
);
const NcProfileHoverCard = __component__.exports;
export {
  NcProfileHoverCard as default
};
//# sourceMappingURL=NcProfileHoverCard-DK5YkGF0.mjs.map
